module.exports = __webpack_public_path__ + "img/bg-paralax-home.0b01051a.png";